import { render, staticRenderFns } from "./newMessageSetting.vue?vue&type=template&id=3c015ffa&scoped=true"
import script from "./newMessageSetting.vue?vue&type=script&lang=js"
export * from "./newMessageSetting.vue?vue&type=script&lang=js"
import style0 from "./newMessageSetting.vue?vue&type=style&index=0&id=3c015ffa&lang=scss&scoped=true"
import style1 from "./newMessageSetting.vue?vue&type=style&index=1&id=3c015ffa&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c015ffa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c015ffa')) {
      api.createRecord('3c015ffa', component.options)
    } else {
      api.reload('3c015ffa', component.options)
    }
    module.hot.accept("./newMessageSetting.vue?vue&type=template&id=3c015ffa&scoped=true", function () {
      api.rerender('3c015ffa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notify/customerMessageManagement/newMessageSetting.vue"
export default component.exports